export default __webpack_public_path__ + "static/select.dark-77e91f97efcd66eb057455ef794b1d06bb11faf812e022f3e7927cf9aae26f72.png";